module.exports = __webpack_public_path__ + "static/img/1.31254927.jpg";